import { createSlice } from "@reduxjs/toolkit";
import { RequiredDocuments, Undertakings,AuditServices, RequiredDocumentsID } from "../utils/constants";
import { hasMatchingIds } from "../service/onboardingService";

export const onboardFormSlice = createSlice({
  name: "onboard",
  initialState: {
    domains: [],
    tradeLicence: "",
    vatRegistration: "",
    nameOfApplicantFirm: "",
    yearOfEstablishment: new Date().getFullYear(),
    numberOfEmployees: "",
    lastYearTurnover: "",
    officeTelephone: "",
    mobileNumber: "",
    emailAddress: "",
    address: "",
    area: "",
    city: "",
    country:"",
    primaryContactDesignation: "",
    primaryContactName: "",
    primaryContactEmail: "",
    primaryContactPhone: "",
    undertakings: Undertakings,
    documents: RequiredDocuments,
    additionalDocuments: [],
    newExtraDocuments:[]

  },
  reducers: {
    setDomain(state, action) {
      const selectedDomains = state.domains
      const domain = action.payload;
      
      let isAdd = true
      state.domains = selectedDomains.filter((d) => {
        if (domain.id == d.id) {
          isAdd = false
          if (domain.subCategory.length) {
            d.subCategory = domain.subCategory
            return d
          }
        } else {
          return d
        }
      })
      if (isAdd && domain.subCategory.length) {
        state.domains = [domain]
      }
    },
   updateDocuments(state, action) {
 

  const auditService = {
    name: 'Registration application form for audit firms',
    id: 'registrationApplicationFormForAuditFirms',
    mandatory: true,
    docId: '',
    url: ''
  };

  if (hasMatchingIds(action.payload, AuditServices)) {
  
    
    // ✅ Check if auditService already exists before adding
    const alreadyExists = state.documents.some(
      doc => doc.id === auditService.id
    );

    if (!alreadyExists) {
      state.documents.splice(2, 0, auditService);
    } 

  } else {
  
    // ✅ Remove if condition no longer matches
    state.documents = state.documents.filter(
      doc => doc.id !== auditService.id
    );
  }


}
,
    updateValue(state, action) {
      state[action.payload.key] = action.payload.value
    },
    updateMandatoryDoc(state, action) {
      state.documents = state.documents.map((doc) => {
        if (doc.id == action.payload.id) {
          return {
            ...doc,
            url: action.payload.url,
            id: action.payload.id,
            docId: action.payload.docId,
            name: doc.name,
            mandatory: doc.mandatory
          }
        }
        return doc
      })
    }, 
    updateAdditionalDoc(state, action) {
    
      state.additionalDocuments = state.additionalDocuments.map((doc) => {
        
        if (doc.id == action.payload.id) {
          return {
            ...doc,
            url: action.payload.url,
            docId: action.payload.docId,
            fileName: doc.fileName,
            mandatory: doc.mandatory
          }
        }
     
        return doc
      })
    },
    addAddtionalDocument(state, action) {
   
      state.additionalDocuments = [...state.additionalDocuments, {
        url: action.payload.url,
        id: action.payload.id,
        docId: action.payload.docId,
        name: action.payload.name
      }]
    },
    updateNewExtraDocument(state, action) {
      
      state.newExtraDocuments = state.newExtraDocuments.map((doc) => {
     
        if (doc.name == action.payload.name) {
       
          return {
            ...doc,
            url: action.payload.url,
            docId: action.payload.docId,
            fileName: doc.fileName,
            mandatory: doc.mandatory
          }
        }
     
        return doc
      })
    },
addNewExtraDocument(state, action) {

  const exists = state.newExtraDocuments.some(
    doc => doc.fileName === action.payload.fileName
  );

  if (exists) return;

  state.newExtraDocuments.push({
    ...action.payload,
    id: action.payload.id || crypto.randomUUID(),
    isNewExtra: true
  });
},
    addAlladditionalDocuments(state, action) {
   
    state.additionalDocuments = action.payload.map(additionalDoc => ({
  ...additionalDoc,
  url: ""
}));
    },
    removeAddtionalDocument(state, action) {
      state.additionalDocuments = state.additionalDocuments.filter(doc => doc.id != action.payload.id)
    },
    checkUndertaking(state, action) {
      state.undertakings = state.undertakings.map(u => {
        if (u.id == action.payload.id) {
          u.checked = action.payload.checked
        }
        return u
      })
    },
    resetForm(state, action) {
      state.domains = []
      state.tradeLicence = ""
      state.vatRegistration = ""
      state.nameOfApplicantFirm = ""
      state.yearOfEstablishment = new Date().getFullYear()
      state.numberOfEmployees = ""
      state.lastYearTurnover = ""
      state.officeTelephone = ""
      state.mobileNumber = ""
      state.emailAddress = ""
      state.address = ""
      state.area = ""
      state.city = ""
      state.country=""
      state.primaryContactDesignation = ""
      state.primaryContactName = ""
      state.primaryContactEmail = ""
      state.primaryContactPhone = ""
      state.undertakings = Undertakings
      state.documents = RequiredDocuments
      state.additionalDocuments = []
       state.newExtraDocuments = []
    }
  }
});

export const onboardFormActions = onboardFormSlice.actions;